import {
  NEWFORM_FETCHITEM_LOAD,
  NEWFORM_FETCHITEM_SUCCEED,
  NEWFORM_FETCHITEM_FAIL,
  NEWFORM_EDITFORM_CHANGE,
  NEWFORM_ENTER_RESET,
  NEWFORM_CREATEITEM_LOAD,
  NEWFORM_CREATEITEM_SUCCEED,
  NEWFORM_CREATEITEM_FAIL,
  NEWFORM_EDITITEM_LOAD,
  NEWFORM_EDITITEM_SUCCEED,
  NEWFORM_EDITITEM_FAIL,
  NEWFORM_DELETEITEM_LOAD,
  NEWFORM_DELETEITEM_SUCCEED,
  NEWFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case NEWFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case NEWFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case NEWFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case NEWFORM_ENTER_RESET:
      return {}
    case NEWFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case NEWFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case NEWFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case NEWFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case NEWFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case NEWFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case NEWFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case NEWFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case NEWFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case NEWFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
